import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/ui/Button.tsx';
import { formatDate } from '@utils/formats.ts';

interface NoOfferEmptyStateProps {
  deliveryDate?: string;
  hasAlternatives: boolean;
  onShowAlternatives: () => void;
}

const NoOfferEmptyState: React.FC<NoOfferEmptyStateProps> = ({ deliveryDate, hasAlternatives, onShowAlternatives }) => {
  const { t } = useTranslation('client');

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full max-w-[360px] bg-gradient-to-br from-surface-lighter-neutral to-white rounded-xl border border-gray-100 p-6 flex flex-col items-center gap-4 shadow-sm">
        <div className="w-14 h-14 rounded-full bg-white border border-gray-100 flex items-center justify-center text-primary shadow-sm">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
            <path d="M3 9h18" stroke="currentColor" strokeWidth="1.6" />
            <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <path d="M9 14l6 4M15 14l-6 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </div>

        <div className="flex flex-col items-center gap-1 text-center">
          <div className="text-zinc-900 text-base font-semibold font-['Borna']">{t('productDetail.noOffer.title')}</div>
          <div className="text-zinc-500 text-sm font-medium font-['Borna'] leading-snug">
            {deliveryDate ? t('productDetail.noOffer.messageWithDate', { date: formatDate(deliveryDate) }) : t('productDetail.noOffer.message')}
          </div>
        </div>

        {hasAlternatives && (
          <div className="w-full mt-1">
            <Button
              label={t('productDetail.noOffer.viewAlternatives')}
              type="primary"
              variant="fill"
              size="md"
              onClick={onShowAlternatives}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NoOfferEmptyState;
